// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".timeline-event{width:24px;height:24px;border-radius:50%;background-color:hsla(0,0%,100%,.16);position:relative}.timeline-event:after{content:\"\";width:6px;height:6px;border-radius:50%;background-color:#80ce1b;position:absolute;left:50%;top:50%;transform:translate(-50%,-50%)}@media (min-width:768px){.timeline-event{width:46px;height:46px}.timeline-event:after{width:12px;height:12px}}", ""]);
// Exports
module.exports = exports;
